import { DocumentIcon, ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';

// Port aus PdfViewer.svelte — Original-Dokument im iframe, Kopfzeile mit
// „Neuer Tab". Der Elternrahmen gibt die Hoehe vor (h-full).
export default function PdfViewer({ src, title = 'Dokument', subtitle, showOpenInNewTab = true, minHeight = '100%' }:
  { src: string; title?: string; subtitle?: string; showOpenInNewTab?: boolean; minHeight?: string }) {
  return (
    <div className="flex h-full min-h-0 flex-col bg-gray-100" style={{ minHeight }}>
      <div className="flex shrink-0 items-center justify-between border-b border-gray-200 bg-white px-4 py-2.5">
        <div className="flex min-w-0 items-center gap-2.5">
          <DocumentIcon className="h-4 w-4 shrink-0 text-primary-500" />
          <div className="min-w-0">
            <div className="text-[11px] font-semibold uppercase tracking-wider text-ps-dark-500">Original-Dokument</div>
            {subtitle && <div className="mt-0.5 truncate font-mono text-[11px] text-ps-dark-400" title={subtitle}>{subtitle}</div>}
          </div>
        </div>
        {showOpenInNewTab && (
          <a href={src} target="_blank" rel="noopener" className="btn-ghost flex items-center gap-1 px-2.5 py-1 text-[11px]" title="In neuem Tab öffnen">
            <ArrowTopRightOnSquareIcon className="h-3 w-3" /> Neuer Tab
          </a>
        )}
      </div>
      <div className="relative min-h-0 flex-1 overflow-hidden">
        <iframe src={src + '#view=FitH'} title={title} className="absolute inset-0 block h-full w-full border-0" />
      </div>
    </div>
  );
}
